import { SiteConfig } from './SiteConfig.interface';

export const mapSiteConfig = (data: any): SiteConfig => {
  return {
    ...data,
  };
};
